export function generateBlockRef() {
    const possibleChars =
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let ref = '';
    for (let i = 0; i < 6; i++) {
        ref += possibleChars.charAt(
            Math.floor(Math.random() * possibleChars.length)
        );
    }

    return ref;
}
